import {
  GetDetailResponse,
  GetListResponse,
  Campaign,
  CreateCampaign,
  UpdateCampaign,
  CampaignNotification,
  CampaignPopupBanner,
  TypeToggleStatus,
  PushNotificationTest,
} from "@app/types";
import HttpService from "@core/services/http/http.service";
import { RequestParams, Signal } from "@core/services/http/http.type";

class _CampaignService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<Campaign>>(
      "/admin/api/v3/campaigns",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public getNotificationList(requestParams?: RequestParams, signal?: Signal) {

    return HttpService.get<GetListResponse<CampaignNotification>>(
      "/admin/api/v3/campaigns/notification",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public getPopupBannerList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<CampaignPopupBanner>>(
      "/admin/api/v3/campaigns/popup-banner",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public getCampaignDetail(campaignId: number) {
    return HttpService.get<GetDetailResponse<Campaign>>(
      `/admin/api/v3/campaigns/${campaignId}/campaign`
    );
  }

  public getPopupBannerDetail(popupBannerId: number) {
    return HttpService.get<GetDetailResponse<CampaignPopupBanner>>(
      `/admin/api/v3/campaigns/${popupBannerId}/popupBanner`
    );
  }

  public getNotificationDetail(key: string) {
    return HttpService.get<GetDetailResponse<CampaignNotification>>(
      `/admin/api/v3/campaigns/${key}/notification`
    );
  }

  public create(campaign: CreateCampaign) {
    return HttpService.post("/admin/api/v3/campaigns", {
      body: { ...campaign },
    });
  }

  public update(campaign: UpdateCampaign) {
    return HttpService.patch("/admin/api/v3/campaigns", {
      body: { ...campaign },
    });
  }

  public delete(campaignId: number) {
    return HttpService.delete(`/admin/api/v2/campaign/${campaignId}`);
  }

  public getCampaignById(campaignId: number) {
    return HttpService.get<GetDetailResponse<Campaign>>(
      `/admin/api/v2/campaign/${campaignId}`
    );
  }

  public toggleStatus(id: number | string, type: TypeToggleStatus) {
    return HttpService.patch(`/admin/api/v3/campaigns/${id}/${type}`);
  }

  public pushNotificationTest(payload: PushNotificationTest) {
    return HttpService.post("/admin/api/v3/campaigns/push-notification-test", {
      body: { ...payload },
    });
  }
}

const CampaignService = new _CampaignService();

export default CampaignService;
